"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";

const sidebarNav = [
  {
    title: "Getting Started",
    items: [
      { title: "Installation", href: "/docs/getting-started/installation" },
      { title: "Authentication", href: "/docs/getting-started/authentication" },
      { title: "AI Integration", href: "/docs/getting-started/ai-integration" },
    ],
  },
  {
    title: "Core Concepts",
    items: [
      { title: ".pen Files", href: "/docs/core-concepts/pen-files" },
      { title: "Design as Code", href: "/docs/core-concepts/design-as-code" },
      { title: "Pencil Interface", href: "/docs/core-concepts/pencil-interface" },
      { title: "Variables", href: "/docs/core-concepts/variables" },
      { title: "Components", href: "/docs/core-concepts/components" },
      { title: "Import and Export", href: "/docs/core-concepts/import-and-export" },
      { title: "Keyboard Shortcuts", href: "/docs/core-concepts/keyboard-shortcuts" },
    ],
  },
  {
    title: "Design and Code",
    items: [
      { title: "Design \u2194 Code", href: "/docs/design-and-code/design-to-code" },
      { title: "Styles and UI Kits", href: "/docs/design-and-code/styles-and-ui-kits" },
    ],
  },
  {
    title: "Troubleshooting",
    items: [
      { title: "Troubleshooting", href: "/docs/troubleshooting" },
    ],
  },
  {
    title: "For Developers",
    items: [
      { title: "The .pen Format", href: "/docs/for-developers/the-pen-format" },
      { title: "Pencil CLI", href: "/docs/for-developers/pencil-cli" },
    ],
  },
];

export default function DocsSidebar() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);

  const sidebar = (
    <nav className="flex flex-col gap-6">
      {sidebarNav.map((section) => (
        <div key={section.title}>
          <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted">
            {section.title}
          </h4>
          <ul className="flex flex-col gap-0.5">
            {section.items.map((item) => {
              const isActive = pathname === item.href;
              return (
                <li key={item.href}>
                  <Link
                    href={item.href}
                    onClick={() => setMobileOpen(false)}
                    className={`block rounded-md px-3 py-1.5 text-sm transition-colors ${
                      isActive
                        ? "bg-accent/10 font-medium text-accent"
                        : "text-muted hover:bg-card-bg hover:text-foreground"
                    }`}
                  >
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );

  return (
    <>
      {/* Mobile toggle */}
      <button
        onClick={() => setMobileOpen(!mobileOpen)}
        className="mb-4 flex items-center gap-2 rounded-lg border border-edge px-3 py-2 text-sm text-muted lg:hidden"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 12h18M3 6h18M3 18h18" />
        </svg>
        Documentation Menu
      </button>

      {/* Mobile sidebar */}
      {mobileOpen && (
        <div className="mb-6 rounded-lg border border-edge bg-card-bg p-4 lg:hidden">
          {sidebar}
        </div>
      )}

      {/* Desktop sidebar */}
      <aside className="hidden w-64 shrink-0 lg:block">
        <div className="sticky top-20 max-h-[calc(100vh-6rem)] overflow-y-auto pr-4">
          {sidebar}
        </div>
      </aside>
    </>
  );
}
